"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const popup_1 = __importDefault(require("../popup"));
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('action-sheet');
const ActionSheet = (props) => {
    const { open, title, actions, cancelText = 'Cancel', cover, maskClosable = true, onCancel, onChange, } = props;
    const handleCancel = (e) => {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
    };
    const handleChange = (action, grid, e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(action, grid, e);
    };
    const handleCloseMask = () => {
        maskClosable && (onCancel === null || onCancel === void 0 ? void 0 : onCancel());
    };
    const renderAction = (action) => (react_1.default.createElement(one_1.View, { key: action.value, className: classnames_1.default(`${prefixCls}-action`, {
            [`${prefixCls}-action-destructive`]: action.type === 'destructive',
        }), onTap: e => handleChange(action, undefined, e) }, action.text));
    const renderGrid = (action) => {
        var _a;
        return (react_1.default.createElement(one_1.View, { key: action.value, className: classnames_1.default(`${prefixCls}-grid`, {
                [`${prefixCls}-action-destructive`]: action.type === 'destructive',
            }) },
            react_1.default.createElement(one_1.View, { className: `${prefixCls}-grid-wrapper` }, (_a = action.text) === null || _a === void 0 ? void 0 : _a.map((item) => (react_1.default.createElement(one_1.View, { key: item.value, className: `${prefixCls}-grid-item`, onTap: e => handleChange(item, action, e) },
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-grid-item-icon` }, item.icon ? (react_1.default.createElement(icon_1.default, { type: item.icon, size: "48px", color: "rgba(0, 0, 0, 0.8)" })) : (item.name)),
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-grid-item-name` }, item.name)))))));
    };
    return (react_1.default.createElement(one_1.View, { className: prefixCls },
        react_1.default.createElement(popup_1.default, { transparent: true, position: "bottom", open: open, onClose: handleCloseMask },
            react_1.default.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-container`, { [`${prefixCls}-cover`]: cover }) },
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-menu` },
                    title ? (react_1.default.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-action`, { [`${prefixCls}-title`]: true }) }, title)) : null, actions === null || actions === void 0 ? void 0 :
                    actions.map(action => action.mode === 'grid' ? renderGrid(action) : renderAction(action))),
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-cancel`, onTap: handleCancel }, cancelText)))));
};
exports.default = ActionSheet;
